import { getComponentsSearchCommands } from 'viewpointBuilder/selectContextTab/commands';
import { getMetamodelViewCommands } from './metaModel/metamodelViewCommands';
import type { ViewpointBuilderCommands } from './types';
import { getViewpointBuilderFiltersCommands } from './addFiltersTab/viewpointBuilderFiltersCommands';
import { getViewpointBuilderNavigationCommands } from './viewpointBuilderNavigation/viewpointBuilderNavigationCommands';
import { getEditTraversalCommands } from './traversals/editTraversalCommands';
import { getMetaInfoCommands } from './viewpointMetaInfo/metaInfoCommands';
import { getViewpointGroupingRulesCommands } from './addGroupingRulesTab/viewpointGroupingRulesCommands';
import { getViewpointBuilderFormattingCommands } from './formattingTabs/viewpointBuilderFormattingCommands';
import { getCollapsePathsCommands } from './collapsePathsTab/collapsePathsCommands';
import { getRequiredComponentsCommands } from './requiredComponentsTab/requiredComponentsCommands';
import { getSelectedViewCommands } from './selectedView/commands';

export const getViewpointBuilderCommands = (
  namespace: string
): ViewpointBuilderCommands => ({
  componentsSearchCommands: getComponentsSearchCommands(namespace),
  metamodelViewCommands: getMetamodelViewCommands(namespace),
  filterCommands: getViewpointBuilderFiltersCommands(namespace),
  navigationCommands: getViewpointBuilderNavigationCommands(namespace),
  editTraversalCommands: getEditTraversalCommands(namespace),
  metaInfoCommands: getMetaInfoCommands(namespace),
  groupingsCommands: getViewpointGroupingRulesCommands(namespace),
  formattingCommands: getViewpointBuilderFormattingCommands(namespace),
  collapsePathsCommands: getCollapsePathsCommands(namespace),
  requiredComponentsCommands: getRequiredComponentsCommands(namespace),
  selectedViewCommands: getSelectedViewCommands(namespace),
});
